import { DCData } from './DCData.ts';

export interface DCCardReader extends DCData {
    terminal_id: string;
    reader_id: string;

    tenant: Reference;
    workplace: Reference;
    client_system: string;

    terminals: Reference[];
    cards: Card[];
    profiles: Profile[];
}

export interface Reference {
    id: string;
    name?: string;
}

export interface Card {
    id: string;
    type: CardType;

    versions: Version[];

    meta: {
        iccsn?: string;
        terminal_id?: string;
        slot_id?: string;
        card_holder_name?: string;

        insertion_time?: string;
        certificate_expiration_date?: string;
    };
}

export enum CardType {
    SMCB = 'SMC-B',
    HBA = 'HBA',
    UNKNOWN = 'UNKNOWN',
}

export interface Version {
    type: VersionType;
    major: string;
    minor: string;
    revision: string;
}

export enum VersionType {
    COS = 'COS',
    OBJECT_SYSTEM = 'OBJECT_SYSTEM',
    ATR = 'ATR',
    GDO = 'GDO',
}

export interface Profile {
    label: string;
    terminals: string[];
}

export interface LegacyDCCardReadersWrapper {
    instance_id: string;
    card_readers: DCCardReader[];
}

export enum CardReadStatus {
    MATCHING = 'MATCHING',
    MERGED = 'MERGED',
    APPLIED = 'APPLIED',
    CANCELLED = 'CANCELLED',
}

export enum CardReadValidationStatus {
    OK = 'OK',
    NONE = 'NONE',
    ONLY_ALLOW_COPYING_DATA = 'ONLY_ALLOW_COPYING_DATA',
}

export enum CardReadActionType {
    READ = 'read',
    APPLY = 'apply',
    MATCHING_SELECT = 'matching_select',
    CANCEL = 'cancel',
}

export interface ReadCardRequestDto {
    card_reader_id: string;
    tenant_id: string;
    workplace_id: string;
    terminal_id: string;

    action: CardReadActionType; // ONLY read
}

export interface FollowUpActionDto {
    op_id: string;

    action: CardReadActionType; // NOT read
}

export interface DiffField {
    label: string;
    old_value: string;
    new_value: string;
}

export interface CardReadResponseDto {
    op_id: string;
    status: CardReadStatus;
    validation_status: CardReadValidationStatus;
    possible_actions: CardReadActionType[];
    matched_patients: string[];
    diff_fields?: DiffField[]; // set when status is "MERGED"
}

export interface CardReadParams {
    instance_id: string;
    dc_user_id?: string;
}

export interface CardReadResponseDtoWrapper {
    data: CardReadResponseDto;
}

export interface GetCardReadersResponse {
    card_readers: DCCardReader[];
}
